import { primitives, tokens } from "@adasupport/byron";
import styled from "styled-components";

import { TextButton } from "components/Common/Primitives";

export const Description = styled.div`
  font-size: ${primitives.fontSize.small};
  font-weight: ${primitives.fontWeight.normal};
  line-height: 21px;
  color: ${tokens.colors.text.main};
`;

export const Strong = styled.strong`
  font-weight: ${primitives.fontWeight.semibold};
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${tokens.colors.border.default};
  margin: ${primitives.spacing.space6} 0;
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${primitives.spacing.space1};
  margin-bottom: ${primitives.spacing.space6};
`;

export const SectionNumber = styled.div`
  color: ${tokens.colors.text.main};
  font-weight: ${primitives.fontWeight.semibold};
  font-size: ${primitives.fontSize.small};
  margin-left: ${primitives.spacing.space1};
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.spacing.space4};
`;

export const FormGrid = styled.div`
  display: grid;
  gap: ${primitives.spacing.space6};
  grid-template-columns: 1fr;
  margin-right: ${primitives.spacing.space4};

  @media (min-width: 768px) {
    grid-template-columns: 1fr minmax(8rem, 14rem);
  }
`;

export const FullWidth = styled.div`
  @media (min-width: 768px) {
    grid-column: 1 / -1;
  }
`;

export const HelpLink = styled(TextButton)`
  display: flex;
  align-items: center;
  gap: ${primitives.spacing.space1};
  white-space: nowrap;
`;

export const ModalContent = styled.div`
  .Modal__section {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const ModalBottom = styled.div`
  display: flex;
  align-items: center;
  font-size: ${primitives.fontSize.small};
  justify-content: space-between;
`;
